export const KBtoMB = (kb: number) => {
  return kb >= 1000000 ? `${(kb / 1000000).toFixed(2)} MB` : `${kb / 1000} KB`;
};

export const bytesToGB = (size: number) => {
  return size / 1e9;
};
